/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/AddAction/Content/Content",
  closePopover
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClickWait({
  children,
  viewPath,
  closePopover
  
})
let onClick1 = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--pt-2-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-8-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 closePopover={closePopover}
 onClick={onClick}
 width="100%"
 type="ghost"
 text="Add action with wait"
/>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 closePopover={closePopover}
 onClick={onClick1}
 width="100%"
 type="ghost"
 text="Add action"
/>
</div>
{children}
</React.Fragment>)
}